import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class ApiService {

    static parameters = [HttpClient]
    constructor(@Inject(HttpClient) private http: HttpClient) {
        this.http = http;
    }
    
    getLeaveReport(data) {
        return this.http.post('/api/Report/getLeaveReport',data);
    }

    getTargetAcheivment(data) {
        return this.http.post('/api/Report/getTargetAcheivment', data);
    }
    
    saveEmpDetails(data) {
        return this.http.post('/api/usermasters/saveEmpDetails', data);
    }

    ssreport(data){
        return this.http.post('/api/Report/SSStatementOverallReport',data)
    }

    getEmpDetails(data) {
        return this.http.post('/api/usermasters/getEmpDetails',data);
    }

    getStockistNameDetails(){
        return this.http.get('/api/Report/getStockistNameDetails');
    }

    

    ssslog(data){
        return this.http.post('/api/Report/SSStatementLog',data)
    }

    SSSlog_Report(){
        return this.http.get('/api/Report/SSStatementLog_Report')
    }


    getIMEIDetails(data) {
        return this.http.post('/api/admin/getIMEIDetails',data);
    }

    getEmpDetailsByFilter(data) {
        return this.http.post('/api/usermasters/getEmpDetailsByFilter' ,data);
    }
 
    getuserreport() {
        return this.http.get('api/Report/userreport');
    }

    getEmployeeAttandance(data) {
        return this.http.post('api/Report/getEmployeeAttandance',data);
    }

    LateWorkingReport(data: any) {
        return this.http.post('api/Report/LateWorkingReport', data);
    }

    getChemistEmployeeDetails(data) {
        return this.http.post('/api/ChemistList/getEmpDetails', data);
    }

    getEmpWiseChemsitData(data) {
        return this.http.post('/api/ChemistList/getEmpWiseChemsitData', data);
    }

    getRoute() {
        return this.http.get('/api/routemaster/getRouteList');
    }
    
    getrouteMaster(data) {
        return this.http.post('/api/routemaster/getRouteMaster', data);
    }

    GetRouteFilterWise(data) {
        return this.http.post('/api/routemaster/GetRouteFilterWise', data);
    }
    
    GetTPFilterWise(data) {
        return this.http.post('/api/routemaster/GetTPFilterWise', data);
    }

    GetDivertRouteFilterWise(data) {
        return this.http.post('/api/routemaster/GetDivertRouteFilterWise', data);
    }
    
    getState() {
        return this.http.get('/api/stateMaster/getState');
    }

    getCity(stateId) {
        return this.http.get('/api/stateMaster/getCity/' + stateId);
    }

    getStateForcampaign() {
        return this.http.get('/api/stateMaster/getStateForcampaign');
    }

    getCityForComapaign(stateId) {
        return this.http.post('/api/stateMaster/getCityForComapaign', stateId);
    }

    getCategoryList() {
        return this.http.get('/api/categoryList/getCategoryList');
    }

    getHeadQuarterList() {
        return this.http.get('/api/headQuarterList/getHeadQuarterList');
    }

    saveAdditionalArea(data) {
        return this.http.post('/api/headQuarterList/saveAdditionalArea', data);
    }

    getAreaCountHQWise() {
        return this.http.get('/api/headQuarterList/getAreaCountHQWise');
    }

    editAreaCountHQWise(data) {
        return this.http.post('/api/headQuarterList/editAdditionalArea', data);
    }

    resetUserIMEI(data) {
        return this.http.post('/api/admin/resetUserIMEI', data);
    }

    inActiveAreaCountHQWise(data) {
        return this.http.post('/api/headQuarterList/inactiveAreaCountHQWise', data);
    }

    ApproveTourPlan(routeId) {
        return this.http.post('/api/admin/approveTP', routeId);
    }

    RejectTourPlan(routeId) {
        return this.http.post('/api/admin/rejectTP', routeId);
    }

    RejectDivertRoute(routeId) {
        return this.http.post('/api/admin/RejectDivertRoute', routeId);
    }

    resetChemist(routeId) {
        return this.http.post('/api/ChemistList/resetChemist', routeId);
    }

    ApproveRoute(routeId) {
        return this.http.post('/api/admin/approveroute', routeId);
    }

    RejectRoute(routeId) {
        return this.http.post('/api/routemaster/RejectRoute', routeId);
    }

    ApproveDivertRoute(routeId) {
        return this.http.post('/api/admin/ApproveDivertRoute', routeId);
    }
    approvedivertedRoute_web(routeId) {
        return this.http.post('/api/admin/approvedivertedRoute_web', routeId);
    }

    getHQMasters() {
        return this.http.get('/api/usermasters/getHQDetails');
    }

    getManagerAllocation() {
        return this.http.get('/api/usermasters/getManagerAllocation');
    }
    
    getAllRoute(data) {
        // return this.http.get('/api/routemaster/getAllRoute');
        //console.log('api service get all route');
        return this.http.post('/api/routemaster/getAllRoute',data)
    }

    getTP(data) {
        return this.http.post('/api/routemaster/getTP', data);
    }

    updateTP(data) {
        return this.http.post('/api/routemaster/updateTP', data);
    }

    gaddTP(data) {
        return this.http.post('/api/routemaster/addTP', data);
    }

    saveRouteMaster(data) {
        return this.http.post('/api/routemaster/saveRouteMaster', data);
    }

    addChemist(data) {
        return this.http.post('/api/ChemistList/CreateChemist', data);
    }

    updateChemist(data) {
        return this.http.post('/api/ChemistList/updateEmployeeChemist', data);
    }

    inactiveChemist(data) {


        return this.http.post('/api/ChemistList/inactiveEmployeechemist', data);
    }

    getChemistForReset(data) {
        return this.http.post('/api/ChemistList/getChemistForReset', data);
    }

    listChemist(data) {
        return this.http.post('/api/ChemistList/employeeChemist', data);
    }

    getChemistListFilterWise(data) {
        return this.http.post('/api/ChemistList/getChemistListFilterWise', data);
    }

    UploadEmployee(data) {

        return this.http.post('/api/ChemistList/uploadEmployeeBulk', data);
    }

    getDivisionList() {
        return this.http.get('/api/divisionList/getDivisionList');
    }

    getlivelatlong(id: any) {
        console.log('id api', id);
        return this.http.post('/api/routemaster/get_emp_route_tracking', id);
    }

    getMapRoute(id: any) {
        // console.log('id api', id);
        return this.http.post('/api/routemaster/routeService', id);
    }

    getStockistMaster() {
        return this.http.get('/api/stockistmasters/getStockistMaster');
    }

    getStockistMaster_web(data:any) {
        return this.http.post('/api/stockistmasters/getStockistMaster_web',data);
    }

    getExpenseMaster(data) {
        return this.http.post('/api/expensemasters/getExpenseMaster',data);
    }

    saveExpense(data: any) {
        return this.http.post('/api/expensemasters/saveExpenseMaster', data);
    }

    updateExpense(data: any) {
        return this.http.post('/api/expensemasters/updateExpenseMaster', data);
    }

    getExpDetais(data: any) {
        return this.http.post('/api/expensemasters/getEmpExpenseDetails', data);
    }

    getStaffTypes() {
        return this.http.get('/api/expensemasters/getStaffTypes');
    }

    getExpenseStmt(data: any) {
        return this.http.post('/api/expensemasters/getExpenseStmt', data);
    }

    GetExpenseStmtForExport(data: any) {
        return this.http.post('/api/expensemasters/GetExpenseStmtForExport', data);
    }

    GetDayWiseCallDetails(data: any) {
        return this.http.post('/api/Report/GetDayWiseCallDetails', data);
    }
    getFirstLastCallDetail(data: any) {
        return this.http.post('/api/Report/getFirstLastCallDetail', data);
    }

    getPOBData(data: any) {
        return this.http.post('/api/POBMaster/getPOBData', data);
    }

    

    getRouteList(id: any) {
        return this.http.get('/api/routemaster/getRouteList/' + id);
    }

    getHQList(id: any) {
        return this.http.get('/api/routemaster/getHQList/' + id);
    }

    disableRoute(id: any) {
        return this.http.post('/api/routemaster/disableRouteMaster', id);
    }

    newretailerlist(data: any) {
      return this.http.post('/api/Report/NewRetailerAdditionlist', data);
    }

    GetTourProgramEditList(data: any) {
      return this.http.post('/api/tourprograms/GetTourProgramEditList', data);
    }
    SaveAndApproveTourProgramList(data: any) {
        return this.http.post('/api/tourprograms/SaveAndApproveTourProgramList', data);
      }
    GetDCRUnlockListForApproval(data: any) {
        return this.http.post('/api/admin/GetDCRUnlockListForApproval', data);
    }
    GetTPDeviationEmployeeList(data: any) {
        return this.http.post('/api/admin/GetTPDeviationEmployeeList', data);
    }
    GetTPDeviatedEmployeeDetails(data: any) {
        return this.http.post('/api/admin/GetTPDeviatedEmployeeDetails', data);
    }
    GetTPDeviationReportForExport(data: any) {
        return this.http.post('/api/admin/GetTPDeviationReportForExport', data);
    }
    DCRUnlockApproval(data: any) {
        return this.http.post('/api/admin/DCRUnlockApproval', data);
    }
    DCRUnlockHistory(data: any) {
        return this.http.post('/api/admin/DCRUnlockHistory', data);
    }

    GetChemistAdditionApprovalList(data: any) {
        return this.http.post('/api/admin/GetChemistAdditionApprovalList', data);
    }

    ApproveRejectEmployeeChemist(data: any) {
        return this.http.post('/api/admin/ApproveRejectEmployeeChemist', data);
    }

    GetTourProgramList(data: any) {
        return this.http.post('/api/tourprograms/GetTourProgramList', data);
    }

    LateDayPlanApproval_web(data: any) {
        return this.http.post('/api/admin/GetLateDayPlannedList_web', data);
    }

    ApproveLateDayPlan(data: any) {
        return this.http.post('/api/admin/ApproveLateDayPlan', data);
    }

    GetTourProgramEmployeeList(data: any) {
        return this.http.post('/api/tourprograms/GetTourProgramEmployeeList', data);
    }
    ApproveTourPlan_Web(data: any) {
        return this.http.post('/api/tourprograms/ApproveTourPlan_Web', data);
    }

    listChemisttransfer(data) {
        return this.http.post('/api/ChemistList/chemistlisttransfer', data);
    }

    ChemistListTransferORCopy(data) {
        return this.http.post('/api/ChemistList/ChemistListTransferORCopy', data);
    }

    getExpenseEligiibiltyData(data: any) {
        return this.http.post('/api/admin/getExpenseEligiibiltyData', data);
    }
    
    getDailyExpenseData(data: any) {
        return this.http.post('/api/admin/getDailyExpenseData', data);
    }
    
    getNonListedCall(data: any) {
        return this.http.post('/api/admin/getNonListedCall', data);
    }

    getMenuList(data: any) {
        return this.http.post('/api/admin/getMenuList', data);
    }

    GetClientType() {
        return this.http.get('/api/admin/GetClientType');
    }

    getScreenName(data: any) {
        return this.http.post('/api/admin/getScreenName', data);
    }

    InsertScreenMapping(data: any) {
        return this.http.post('/api/admin/InsertScreenMapping', data);
    }
}